import IntegradorFinxInterceptor from '@/Apis/IntegradorFinx/Services/IntegradorFinxInterceptor'
import IntegradorFinxFactoryResponse from '@/factories/IntegradorFinxFactoryResponse'

const factory = new IntegradorFinxFactoryResponse()
const api = new IntegradorFinxInterceptor()

export default {
  async getAllClientes() {
    const response = await api.get('v1/clientes')
    return factory.build(response)
  },

  async getIntegracoesByClienteKey(clienteKey: string) {
    const response = await api.get(`v1/integracao/cliente?clientekey=${clienteKey}`)
    return factory.build(response)
  },
}
